module.exports = __webpack_public_path__ + "img/zhst2.4ca2809d.png";